module.exports = __webpack_public_path__ + "img/meli.34dc1cc8.png";